var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0_2109_5870)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2109_5870",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2109_5870",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2109_5870",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADnUlEQVR4nO2dW6gNURjHfxy3wpFyeXQvklIuJ3fvJ1I6ES8kHkQpvBAdKYk6SXl1yC0l5VGePDgunQeUIiLlklyTy4Oc0co6pR1mrb1n9qxZ8//VV6fdnplvrd/MrJm1Ot8GIYQQQgghhBA+TAF2A902dgGTvfYgMmEIcBz4ASQ1YT47BgxWXzeHgcCVv4iojcv2uyJntjrI6I8tspE/Tz2EPJGQfJnsIaM/JkpKfiyuQ8giCcmP5XUIMdsICYmfaUBXHVdIl91WZMAoYDtwvw4RtXEX2Aa0yow/rcAB4GMGImrjA9AJjJQYN9YCr3IQURsvgTWS8m9GAxebIKI2Lthbo/iDqcDDAmT0x2Nguoz8ps3e15OC4z0wt+pS5gOfApCR2DAPEXOoKGaO6U0dnfYWOAVssGf0GLv2Mdj+bT7bCJy2Z73v/l8DE6gYw4B7nh11B1htF6dcMd/tAHrreGcxOVaGEx6d88o+CjfKOnv2ux7XrEhWgiVAn2OnXAXGZnjsccA1x2P3VWGmuMVjGuQkMCiHHAbZMcj11hX1MvB6x444n3NHDLCDvksu0b7Nm0544NABtz0H7noZ6jjYmys6SpY5NP4rMKnJMwTfHPIyK5XR4XLf3lNAXvsdx7PoBvO3KY1+B4woILfhjrmZNkTDQoez8FCB+R12yM/MuUXDTocGzygwv5kO+e0gIs6lNPZZ0QkCz1NyPENE3Epp7NmiE+T3u8//cuwhItKWZPcWnSCwLyXHF0TEl5TGbio6QWBzSo6fiYifJZieWJuSo2lDNKQ9wZg1i6LpcMgzGiQkMCQkMCQkMCQkMCQkMCQkMCQkMCQkMCQkMCQkMCQkMCQkMCQkMCQkMCQkMCQkMCQkMCQkMCQkMCQkMCQkMCQkMCQksFJLsQhppeSYBtyMSEivrVoUtYwyCUnKKsVHRtmEJGWT0mr/l8KnAk+7rcIzp8Bo9ywp2FOGMcX3yih79IZ8pVRNRhKylKrKSEKUUnUZSWhSfJ5OYo8OAkBCkJAkgKtBVwjFd3gphIxu0ovbwQY66kCTcgxiUG8WNxoQcr3o5GNjfAa3kyyLaVaeBRkIiaq8UtGsyECI2YfIiLYMhMyTjWzL8H1vQMY3uw+RIZcbEHJJJrJnlkNVob+F2Wa2hBRTZCwJtDgaMVfHPuoh44jdRuTMKuDRf0SY37NaKQvNpQVYan+TsNtWn+60P4cRVdFjIYQQQgghhCBHfgGgmDb26+/i9wAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.76db34987f4ca633ffd8480d6d0f1220.svg";
export { ForwardRef as ReactComponent };